import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./FloatingWhatsAppButton.css"; // Importando o CSS externo

const FloatingWhatsAppButton = () => {
  const phoneNumber = "5531996092454"; // Substitua pelo seu número do WhatsApp

  const openWhatsApp = () => {
    window.open(`https://wa.me/${phoneNumber}`, "_blank");
  };

  return (
    <button onClick={openWhatsApp} className="floating-whatsapp-button">
      <FaWhatsapp size={30} />
    </button>
  );
};

export default FloatingWhatsAppButton;